import { useQuery } from '@tanstack/vue-query';
import type {
  SignUpProspectGetReferredRequestType,
  SignUpProspectGetReferredResponseType,
} from '@magma-app/magma-types/sign-up-prospect';
import { instances } from '@/services/http';

export const useReferralInvite = (
  payload: SignUpProspectGetReferredRequestType
) => {
  return useQuery({
    queryKey: ['referrals-invite', payload.referredUuid, payload.ambassadorRefId, payload.referralCampaignUuid] as const,
    queryFn: async () => {
      const query = {
        referredUuid: payload.referredUuid,
        ambassadorRefId: payload.ambassadorRefId,
        referralCampaignUuid: payload.referralCampaignUuid,
      };

      // transform query object to query string params
      const queryString = Object.entries(query)
        .filter(
          ([, value]) => value !== undefined && value !== null && value !== ''
        )
        .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
        .join('&');

      const response = await instances.main.get(
        `/sign-up-prospect/referred?${queryString}`
      );
      return response.data as SignUpProspectGetReferredResponseType;
    },
    staleTime: 0,
    refetchOnWindowFocus: true,
    retry: 0,
  });
};
